/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityFindingsFilters
 */
export interface ControlEntityFindingsFilters {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsFilters
     */
    level?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsFilters
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsFilters
     */
    status?: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityFindingsFilters interface.
 */
export function instanceOfControlEntityFindingsFilters(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityFindingsFiltersFromJSON(json: any): ControlEntityFindingsFilters {
    return ControlEntityFindingsFiltersFromJSONTyped(json, false);
}

export function ControlEntityFindingsFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityFindingsFilters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'level': !exists(json, 'level') ? undefined : json['level'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function ControlEntityFindingsFiltersToJSON(value?: ControlEntityFindingsFilters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'level': value.level,
        'tags': value.tags,
        'status': value.status,
    };
}

